module.exports = __webpack_public_path__ + "img/send__light.a3dc5e07.svg";